import { useState, useEffect } from "react";
import Api from '../components/api/api';
import { saveAs } from 'file-saver';
export const useDevicesState = (organisationId, token) => {
    const [kiosks, setKiosks] = useState(null);
    const [orderedCameras, setOrderedCameras] = useState(null);
    const allCamerasUrl = '/organisation/' + organisationId + '/devices' + '/cameras';
    const allKiosksUrl = '/organisation/' + organisationId + '/devices' + '/kiosks';
    const [camerasLoading, setCamerasLoading] = useState(false);
    const [kiosksLoading, setKiosksLoading] = useState(false);

    const getCameras = () => {
        setCamerasLoading(true);
        Api.getCameras(
            0,
            (data) => {
                setOrderedCameras(data.sort((d1, d2) => new Date(d1.lastHeartbeat).getTime() - new Date(d2.lastHeartbeat).getTime()));
                setCamerasLoading(false);
            },
            (error) => {
                console.log(error);
                setCamerasLoading(false)
            },
            organisationId,
            token
        )
    };

    const getKiosks = () => {
        setKiosksLoading(true);
        Api.getKioskDevices(
            (data) => {
                setKiosks(data);
                setKiosksLoading(false);
            },
            (error) => {
                console.log(error)
                setKiosksLoading(false)
            },
            organisationId,
            token
        )
    };

    const exportCameras = () => {
        setCamerasLoading(true)
        Api.getCameras(
            1,
            (blob, filename) => {
                saveAs(blob, filename)
                setCamerasLoading(false)
            },
            error => {
                console.log(error)
                setCamerasLoading(false)
            },
            organisationId,
            token
        )
    }

    useEffect(() => {
        getCameras();
        getKiosks();
    }, []);

    return {
        orderedCameras,
        kiosks,
        allCamerasUrl,
        allKiosksUrl,
        getCameras,
        exportCameras,
        getKiosks,
        camerasLoading,
        kiosksLoading
    }
}